export const peripheryAddresses = {
  adaptiveCurveIRMFactory: "0x104BA4D746cf71F23341a7c855271A5E7dD19F58",
  capRiskStewardFactory: "0xC9f9209291FC1F0D6e859966B7ffB984a5e67709",
  edgeFactory: "0x088af3Ce37f42b6925C0C2DAa4d58b90fd186010",
  edgeFactoryPerspective: "0x0C13cf54c341a0F91939685dCB1C9b75c2A6f595",
  escrowedCollateralPerspective: "0x19747Fb40074F8cC32fd24445fAce1fCe11BD281",
  eulerEarnFactoryPerspective: "0x068f7C1f56B3963Beeb1ef4474bca4dfe83FDc37",
  eulerEarnGovernedPerspective: "0x23559eF969252b81d8DA2b86a76D85fb602860Ad",
  eulerEarnPublicAllocator: "0x2524762ddb853AB1e572B81E5E6377a8a1536aA5",
  eulerUngoverned0xPerspective: "0x299f86BbB552F74Be79A687c565aC52452C0a02d",
  eulerUngovernedNzxPerspective: "0xC2675790c775D385425D72652ded5f299Fbb2868",
  evkFactoryPerspective: "0x4247432b4f9c32e99ecC2Ff7bAdd98783EecFA6F",
  externalVaultRegistry: "0xe41338Ccac8121fb472817c58c485776E77f3Eea",
  feeCollector: "0x0000000000000000000000000000000000000000",
  feeFlowController: "0x95F21cD90057BBdC6fAc3f9b94D06b53C24B278c",
  feeFlowControllerUtil: "0xBBd929f6c61b59248eD660213C0129a119d54306",
  fixedCyclicalBinaryIRMFactory: "0x53A37B5d8a30a49bCB463eF33d610d5E5040C64A",
  governedPerspective: "0x0d1ABCcBa91F074DeA11AdCc679C61326b6145AC",
  governorAccessControlEmergencyFactory:
    "0xcA14D397219808F39724607e6401bD8C46CbF65f",
  irmRegistry: "0x9a05B935c2ABeD87b4d89c3E74dA253ffc49a2c1",
  kinkIRMFactory: "0xcad498936E09f38f18eD8375AeCD1d46689e7086",
  kinkyIRMFactory: "0x34E21196d7A303EE06c25aEF3B9CCD111c15c9aC",
  oracleAdapterRegistry: "0x0345D8a0Be83834B4611D7D20B661D0Bd2536928",
  oracleRouterFactory: "0x80528F014E84658e85D3C6D4896A29Fa933Be696",
  swapVerifier: "0x0d7938D9c31Cd7dD693752074284af133c1142de",
  swapper: "0x6E1C286e888Ab5911ca37aCeD81365d57eC29a06",
  termsOfUseSigner: "0xB1F64129ba3115DACaf294B07bCBF13CFFbBF1Af",
} as const
